import React, { useRef, useState } from "react";

export default function ResizableSidebar({ children, minWidth = 180, maxWidth = 400, initialWidth = 260 }) {
  const [width, setWidth] = useState(initialWidth);
  const sidebarRef = useRef(null);
  const isResizing = useRef(false);

  const handleMouseDown = (e) => {
    isResizing.current = true;
    document.body.style.cursor = "col-resize";
  };

  const handleMouseMove = (e) => {
    if (!isResizing.current) return;
    const newWidth = Math.min(Math.max(e.clientX, minWidth), maxWidth);
    setWidth(newWidth);
  };

  const handleMouseUp = () => {
    isResizing.current = false;
    document.body.style.cursor = "";
  };

  React.useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  });

  return (
    <div
      ref={sidebarRef}
      style={{
        width,
        minWidth,
        maxWidth,
        background: "#232b21",
        color: "#fff",
        borderRight: "1px solid #222",
        padding: "1em 0",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        height: "100vh"
      }}
    >
      {children}
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "6px",
          height: "100%",
          cursor: "col-resize",
          zIndex: 100,
          background: "rgba(0,0,0,0.05)"
        }}
        onMouseDown={handleMouseDown}
      />
    </div>
  );
}